import { IncentivesDTO } from '@bonusly/user-awards';
import { createBoundContext } from '@bonusly/design-system';

interface IncentivesContextValue {
	groups: IncentivesDTO['groups'] | undefined;
	isLoading: boolean;
	isEmpty: boolean;
	layout: 'grid' | 'list';

	setGridView: () => void;
	setListView: () => void;
}

export const [IncentivesProvider, useIncentivesContext] = createBoundContext<IncentivesContextValue>({
	hookName: 'useIncentivesContext',
	name: 'IncentivesContext',
	providerName: 'IncentivesProvider',
});
